import { Component, OnInit } from '@angular/core';
import { CatalogueService } from 'src/app/lib/services/catalouge.service';
import { StorageService } from 'src/app/lib/services/storage.service';
import { Constants } from 'src/app/config/constants';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/lib/services/common.service';

@Component({
    selector: 'app-updated-product-list',
    templateUrl: './updated-product-list.component.html',
    styleUrls: ['./updated-product-list.component.scss'],
    standalone: false
})
export class UpdatedProductListComponent implements OnInit {
  sortedData: any[] = [];
  dataSource: any[] = [];
  pageSize: number = 10;
  pageLimits: number[] = [10, 50, 100];
  currentPage: number = 0;
  totalPages: number = 0;
  updatedDataStatus: any;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private router: Router,
    private catalogueService: CatalogueService,
    public commonService: CommonService,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.loadUpdatedDataStatus();
    this.fetchDataByShop();
  }

  private loadUpdatedDataStatus(): void {
    this.updatedDataStatus = this.storageService.getItem('updateDataStatus');
  }

  private fetchDataByShop(): void {
    const shopId = this.storageService.getItem(Constants.SHOP_ID);

    this.catalogueService.getDataByShop(shopId).subscribe({
      next: (res: any) => this.processFetchedData(res.data),
      error: (error) => this.commonService.danger(error.error.error.message),
    });
  }

  private processFetchedData(data: any[]): void {
    this.sortedData = data.map((product) => this.mergeUpdatedStatus(product));
    this.calculateTotalPages();
    this.updatePagination();
  }

  private mergeUpdatedStatus(product: any): any {
    const updateInfo = this.updatedDataStatus.find((item: any) => item.ProductId === product.ProductId);
    return updateInfo
      ? { ...product, Updatereport: updateInfo.Updatereport, Updatestatus: updateInfo.Updatestatus }
      : product;
  }

  private calculateTotalPages(): void {
    this.totalPages = Math.ceil(this.sortedData.length / this.pageSize);
  }

  private updatePagination(): void {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSource = this.sortedData.slice(startIndex, endIndex);
  }

  filterProducts(event: Event): void {
    const query = (event.target as HTMLInputElement).value.toLowerCase();
    const filteredData = this.sortedData.filter((product) =>
      Object.values(product).join(' ').toLowerCase().includes(query)
    );
    this.updateFilteredData(filteredData);
  }

  private updateFilteredData(filteredData: any[]): void {
    this.currentPage = 0;
    this.dataSource = filteredData.slice(0, this.pageSize);
    this.totalPages = Math.ceil(filteredData.length / this.pageSize);
  }

  changePage(newPage: number): void {
    if (newPage >= 0 && newPage < this.totalPages) {
      this.currentPage = newPage;
      this.updatePagination();
    }
  }

  updatePageLimit(event: Event): void {
    this.pageSize = +(event.target as HTMLSelectElement).value;
    this.currentPage = 0;
    this.calculateTotalPages();
    this.updatePagination();
  }

  sortTable(column: string): void {
    this.sortDirection = this.sortColumn === column && this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortColumn = column;
    this.sortedData.sort((a, b) => this.compareValues(a[column], b[column]));
    this.currentPage = 0;
    this.updatePagination();
  }

  private compareValues(valueA: any, valueB: any): number {
    valueA = valueA || '';
    valueB = valueB || '';
    if (this.sortDirection === 'asc') {
      return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
    }
    return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
  }

  getStatusClass(status: string): string {
    const statusClasses: { [key: string]: string } = {
      published: 'bg-teal',
      unpublished: 'bg-violet',
      'Available tomorrow': 'bg-blue',
      Updated: 'status-updated',
      Failed: 'status-failed',
      Ignored: 'status-ignored',
      pending: 'status-pending',
    };
    return statusClasses[status] || 'bg-secondary';
  }

  capitalize(value: string): string {
    return value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : '';
  }

  gotoMyCatalog(): void {
    this.router.navigate(['/bulk-update']);
  }

  getProductStatusClass(status: string): string {
    const productStatusClasses: { [key: string]: string } = {
      published: 'status-published',
      unpublished: 'status-unpublished',
      'Available tomorrow': 'status-tomorrow',
      pending: 'status-pending',
    };
    return productStatusClasses[status] || '';
  }
}
